import React from 'react';

export const BlockAugmentedContainer = React.lazy(
    () =>
        import(
            /* webpackChunkName: 'block-augmented-container' */
            './BlockAugmentedContainer'
        ),
);
